// import Landing from './components/Landing/Landing';
import MainRoutes from "./MainRoutes";
import { Toaster } from "react-hot-toast";
import "./globalCss/variables.css";
import "./globalCss/global.css";
import "./App.css";

function App() {
  return (
    <div className="App">
      <Toaster
        position="bottom-center"
        toastOptions={{
          duration: 5000,
        }}
      />
      <MainRoutes />
    </div>
  );
}

export default App;
